const PATH = "/api/v1/feedback";

const ENDPOINTS = {
  OLD_FEEDBACK_ZOBU_REVIEW_ADD: "/zobu/review/",
};

export type OldFeedbackEndpoints = keyof typeof ENDPOINTS;
export const OldFeedbackCollection = { PATH, ENDPOINTS };
